import axios from '@/utils/request'
import { getParmeterSplic } from '@/utils/utils'

/**
 * @description  公告管理-分页查询账号集合
 * @param params
 * pageSize 分页查询每页数据条数
 * pageNum 分页查询第X页
 * keyword 检索关键词
 * @returns
 */
 export async function getTableData(params) {
  return axios.get(`/v2/feedback/api/announcement/list`,{params})
}

/**
 * @description  公告管理-新增公告
 * @param params
 * title 	标题
 * content 内容
 * noticeType 通知类型（1、平台弹窗2、跑马灯）
 * validityPeriod 有效期
 * @returns
 */
 export async function addAnnouncement(params) {
  return axios.post(`/v2/feedback/api/announcement/one`,params)
}


/**
 * @description  公告管理-新增公告
 * @param params
 * id 	id
 * status 1、启动2、停止
 * @returns
 */
 export async function changeAnnouncementStatus(params) {
  return axios.put(`/v2/feedback/api/announcement/status`,params)
}


/**
 * @description  公告管理-删除公告
 * @param params
 * id 	id
 * @returns
 */
 export async function deleteAnnouncement(params) {
  return axios.delete(`/v2/feedback/api/announcement/one`,{params})
}

/**
 * @description  公告管理-获取最新的公告
 * @param params
 * id 	id
 * @returns
 */
 export async function getLastOneAnn(params) {
  return axios.get(`/v2/feedback/api/announcement/lastOne`,{params})
}

/**
 * @description  公告管理-修改公告查阅记录
 * @param params
 * id 	id
 * @returns
 */
 export async function getAnnLog(params) {
  return axios.post(`/v2/feedback/api/announcement/log?id=${params.id}&userName=${params.userName}`)
}

